module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "main",
    attrs: {
      "id": "indexPage"
    }
  }, [_c('van-swipe', {
    staticClass: "my-swipe",
    attrs: {
      "autoplay": 3000,
      "indicator-color": "white"
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../images/index_top.png"),
      "alt": "",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../images/shop_top.jpeg"),
      "alt": "",
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "detail clearfix"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.toRange()
      }
    }
  }, [_vm._v("查看保险详情")])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('qa', {
    attrs: {
      "type": 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-image"
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("南京尚网网络科技有限公司对以上信息保留最终解释权")]), _vm._v(" "), _c('div', {
    staticClass: "button-fixed"
  }, [_c('p', {
    staticClass: "button-item",
    attrs: {
      "id": "createBtn"
    },
    on: {
      "click": function($event) {
        return _vm.goCreate('personal')
      }
    }
  }, [_vm._v("个人参保")]), _vm._v(" "), _c('p', {
    staticClass: "button-item",
    on: {
      "click": function($event) {
        return _vm.goCreate('store')
      }
    }
  }, [_vm._v("商户参保")])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "model"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "title"
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }), _vm._v(" "), _c('p', {
    staticClass: "btns",
    staticStyle: {
      "display": "none"
    }
  }, [_c('span', {
    staticClass: "cancel"
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "confirm"
  }, [_vm._v("确定")])]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": require("../images/index_wifilogo.png"),
      "width": "31.733%"
    }
  }), _vm._v(" "), _c('p', [_vm._v("一键连WiFi，一直有保障")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "protect"
  }, [_c('p', [_vm._v("保障清单")]), _vm._v(" "), _c('div', {
    staticClass: "line left"
  }), _vm._v(" "), _c('div', {
    staticClass: "line right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("连WiFi意外损失累计最高赔付")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("\n          ￥\n          "), _c('span', {
    staticClass: "big"
  }, [_vm._v("100,000")]), _vm._v("元\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("连WiFi意外损失单次最高赔付")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("\n          ￥\n          "), _c('span', {
    staticClass: "big"
  }, [_vm._v("20,000")]), _vm._v("元\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("保障期限")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("一年")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("参保费用")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("\n          ￥\n          "), _c('span', {
    staticClass: "big"
  }, [_vm._v("0.00")]), _vm._v("元\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail clearfix"
  }, [_c('div', {
    staticClass: "protect"
  }, [_c('p', [_vm._v("专属特色")]), _vm._v(" "), _c('div', {
    staticClass: "line left"
  }), _vm._v(" "), _c('div', {
    staticClass: "line right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "left-panel"
  }, [_c('div', {
    staticClass: "icon icon1"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#333333"
    }
  }, [_vm._v("全方位保障")]), _vm._v(" "), _c('p', [_vm._v("所有通过WiFi万能钥匙")]), _vm._v(" "), _c('p', [_vm._v("连WiFi的上网行为")])]), _vm._v(" "), _c('div', {
    staticClass: "right-panel"
  }, [_c('div', {
    staticClass: "icon icon2"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#333333"
    }
  }, [_vm._v("官方VIP通道")]), _vm._v(" "), _c('p', [_vm._v("极速处理您的WiFi安全")]), _vm._v(" "), _c('p', [_vm._v("险理赔需求")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e9e457e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home.vue
// module id = 835
// module chunks = 1